import { render, staticRenderFns } from "./PayPalCasesFilter.vue?vue&type=template&id=1dda8ddd&scoped=true"
import script from "./PayPalCasesFilter.vue?vue&type=script&lang=js"
export * from "./PayPalCasesFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dda8ddd",
  null
  
)

export default component.exports